module.exports = __webpack_public_path__ + "img/step-1.c07e208d.png";